const LayoutFomation = (props: any) => {
    return <div>layout </div>
}


export default LayoutFomation